import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Swal from 'sweetalert2';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Avatar from '@mui/material/Avatar';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDInput from 'components/MDInput';
import MDSelect from 'components/MDSelect';
import MDCheckbox from 'components/MDCheckbox';
import TableHeader from 'components/Table/TableHeader';
import TabPanel from 'components/TabPanel/TabPanel';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Navbar from 'examples/Navbars/NavBar';
import Footer from 'examples/Footer';
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';

const initAttr = {
  id: '',
  code: '',
  name: '',
  name_en: '',
  dep_id: 0,
  enable: 'Y',
  created_at: '',
  updated_at: '',
};

const initFind = {
  search: '',
  order_by: 'tb.id',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

const initNavigate = {
  first: '',
  prev: '',
  next: '',
  last: '',
};

function Category() {
  const mod = 'products_level_category';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [navigate, setNavigate] = useState(initNavigate);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDel, setModalDel] = useState(false);
  const [tab, setTab] = useState(0);
  const [cboDep, setCboDep] = useState([]);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'tb.id', label: t(`attr.id`), align: 'center', width: 40 },
    { id: 'tb.code', label: t(`attr.code`), align: 'left' },
    { id: 'tb.name', label: 'ชื่อ', align: 'left' },
    { id: 'tb.name_en', label: 'ชื่อ (EN)', align: 'left' },
    { id: 'tb.dep_name', label: 'กลุ่มสินค้า', align: 'left' },
    { id: 'count_product', label: 'จำนวนสินค้า', align: 'right', sort: false },
    { id: 'tb.enable', label: t(`attr.enable`), align: 'center' },
    { id: 'edit', label: '', align: 'center', sort: false },
    { id: 'delete', label: '', align: 'center', sort: false },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      role_id: data.role_id,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const open = (item) => {
    setLoading(true);
    setConfirm(false);
    setAttr(initAttr);

    FetchData('GET', `/${mod}/${item.id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(result.data);
        setModalEdit(true);

        setLoading(false);
      }
    });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(initAttr);
        setCboDep(result.department);

        if (id === undefined) {
          view(find);
        } else {
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.code, 1)) return;
    if (!Func.verifyLength(attr.name, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);

    FetchData('PUT', `/${mod}`, app.token, {
      code: attr.code.toUpperCase(),
      name: attr.name,
      name_en: attr.name_en,
      enable: attr.enable,
      dep_id: attr.dep_id,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.dep_id, 1)) return;
    if (!Func.verifyLength(attr.code, 1)) return;
    if (!Func.verifyLength(attr.name, 1)) return;

    setConfirm(true);
  };

  const edit = () => {
    setLoading(true);
    setModalEdit(false);

    FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
      dep_id: attr.dep_id,
      code: attr.code.toUpperCase(),
      name: attr.name,
      name_en: attr.name_en,
      enable: attr.enable,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        setModalEdit(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const del = () => {
    setLoading(true);
    setModalDel(false);
    FetchData('DELETE', `/${mod}/${attr.id}`, app.token, {}).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.deletecomplete`), 'success');
      } else {
        showNotify(t(`alert.deleteerror`), 'error');
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const copyLink = (link) => {
    navigator.clipboard.writeText(link);
    showNotify(t(`alert.copycomplete`), 'success');
  };

  const enableDisplay = (inp) => {
    if (inp === 'Y') return <Icon color='info'>verified</Icon>;
    return <Icon color='error'>not_interested</Icon>;
  };

  const btnEdit = (item) => {
    return (
      <Tooltip title={t(`element.edit`)}>
        <MDButton variant='text' color='success' size='small' iconOnly onClick={() => open(item)}>
          <Icon>border_color</Icon>
        </MDButton>
      </Tooltip>
    );
  };

  const btnDel = (item) => {
    return (
      <MDButton
        variant='text'
        color='error'
        size='small'
        iconOnly
        onClick={() => {
          setConfirm(false);
          setAttr(item);
          setModalDel(true);
        }}
      >
        <Icon>delete</Icon> {t(`element.delete`)}
      </MDButton>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            <Card sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                  <MDBox
                    noValidate
                    component='form'
                    role='form'
                    onSubmit={(e) => {
                      e.preventDefault();
                      view({ ...find, period: 'ALL', page: 1 });
                    }}
                  >
                    <MDInput
                      name='searchform'
                      fullWidth
                      value={find.search}
                      type='search'
                      onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                        ),
                        autoComplete: 'off',
                      }}
                    />
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              onClick={() => {
                setAttr(initAttr);
                setConfirm(false);
                setModalAdd(true);
              }}
            >
              <Icon>post_add</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='center'>{row.id}</TableCell>
                      <TableCell align='left'>{row.code}</TableCell>
                      <TableCell align='left'>{row.name}</TableCell>
                      <TableCell align='left'>{row.name_en}</TableCell>
                      <TableCell align='left'>{row.dep_name}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.count_product)}</TableCell>
                      <TableCell align='center'>{enableDisplay(row.enable)}</TableCell>
                      <TableCell align='center'>{btnEdit(row)}</TableCell>
                      <TableCell align='center'>{btnDel(row)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderFormInfo = () => {
    return (
      <MDBox className='card' p={2} mb={2}>
        <MDTypography variant='h5' mb={3}>
          ภาพประกอบ
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {attr.image === '' ? null : (
              <MDBox component='img' src={attr.image} alt={attr.image} width='100%' height='100%' />
            )}
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderFormData = () => {
    return (
      <MDBox className='card' p={2} mb={2}>
        <MDTypography variant='h5' mb={3}>
          ข้อมูล
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label='รหัส *'
              onChange={(e) => setAttr({ ...attr, code: e.target.value })}
              value={attr.code}
              variant='standard'
              inputProps={{
                maxLength: 10,
                autoComplete: 'off',
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='ชื่อ (TH) *'
              onChange={(e) => setAttr({ ...attr, name: e.target.value })}
              value={attr.name}
              variant='standard'
              inputProps={{
                autoComplete: 'off',
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='ชื่อ (EN)'
              onChange={(e) => setAttr({ ...attr, name_en: e.target.value })}
              value={attr.name_en}
              variant='standard'
              inputProps={{
                autoComplete: 'off',
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDCheckbox
              label={`${t(`attr.enable`)}`}
              checked={attr.enable === 'Y'}
              onChange={(e) => setAttr({ ...attr, enable: e.target.checked ? 'Y' : 'N' })}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MDSelect
            label='กลุ่มสินค้า *'
            labelDefault={t(`element.please_select`)}
            data={cboDep}
            value={attr.dep_id}
            onChange={(e) => setAttr({ ...attr, dep_id: e.target.value })}
            inputProps={{
              autoComplete: 'off',
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label='รหัส *'
            onChange={(e) => setAttr({ ...attr, code: e.target.value })}
            value={attr.code}
            variant='standard'
            inputProps={{
              autoComplete: 'off',
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label='ชื่อ (TH) *'
            onChange={(e) => setAttr({ ...attr, name: e.target.value })}
            value={attr.name}
            variant='standard'
            inputProps={{
              autoComplete: 'off',
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label='ชื่อ (EN)'
            onChange={(e) => setAttr({ ...attr, name_en: e.target.value })}
            value={attr.name_en}
            variant='standard'
            inputProps={{
              autoComplete: 'off',
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDCheckbox
            label={`${t(`attr.enable`)}`}
            checked={attr.enable === 'Y'}
            onChange={(e) => setAttr({ ...attr, enable: e.target.checked ? 'Y' : 'N' })}
          />
        </Grid>
      </Grid>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth='xs' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderEdit = () => {
    return (
      <Dialog open={modalEdit} maxWidth='xs' keepMounted aria-describedby='dialog-edit' fullWidth>
        <DialogTitle>
          {t(`element.edit`)} #{attr.id}
          <IconButton
            aria-label='close'
            onClick={() => setModalEdit(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={edit}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='success' onClick={editConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderDelete = () => {
    return (
      <Dialog
        open={modalDel}
        onClose={() => setModalDel(false)}
        maxWidth='sm'
        keepMounted
        aria-describedby='dialog-delete'
      >
        <DialogTitle>
          {t(`element.delete`)} #{attr.id}
          <IconButton
            aria-label='close'
            onClick={() => setModalDel(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText p={5}>{t(`alert.confirm_delete_title`)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setModalDel(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='gradient' color='error' onClick={del}>
                  <Icon>delete</Icon>&nbsp;{t(`element.deleteconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='error' onClick={() => setConfirm(true)}>
              <Icon>delete</Icon>&nbsp;{t(`element.delete`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderNavigate = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={6}>
            <NavLink to={`/${mod}`}>
              <MDButton variant='contained' color='dark'>
                <Icon>arrow_back</Icon>&nbsp;{t(`element.back`)}
              </MDButton>
            </NavLink>
          </Grid>
          {navigate.first === '' ? null : (
            <Grid item xs={6}>
              <MDBox display='flex' justifyContent='flex-end' gap={1}>
                <NavLink to={`/${mod}/${navigate.first}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.first === id}
                  >
                    <Icon>first_page</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.prev}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.prev === id}
                  >
                    <Icon>navigate_before</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.next}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.next === id}
                  >
                    <Icon>navigate_next</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.last}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.last === id}
                  >
                    <Icon>last_page</Icon>
                  </MDButton>
                </NavLink>
              </MDBox>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderButton = () => {
    return (
      <MDBox display='flex' justifyContent='end' gap={1}>
        <MDButton variant='gradient' color='success' onClick={edit}>
          <Icon>save</Icon>&nbsp;{t(`element.save`)}
        </MDButton>
      </MDBox>
    );
  };

  const renderOpen = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {renderNavigate()}
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card sx={{ p: 2 }}>
              <MDBox sx={{ width: '100%' }}>
                <MDBox>
                  <Tabs value={tab} onChange={(e, v) => setTab(v)} aria-label='tabs-addedit'>
                    <Tab label={t(`element.info`)} />
                    <Tab label={t(`attr.image`)} />
                  </Tabs>
                </MDBox>
                <TabPanel value={tab} index={0}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} xl={6}>
                      <MDTypography variant='h3'>{attr.code}</MDTypography>
                    </Grid>
                    <Grid item xs={12} xl={6}>
                      {renderButton()}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                      {renderFormInfo()}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                      {renderFormData()}
                    </Grid>
                  </Grid>
                </TabPanel>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderPage = () => {
    if (id === undefined) return renderList();
    return renderOpen();
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.product`), t(`menu.products_level_category`)]} />
      {renderPage()}
      {renderAdd()}
      {renderEdit()}
      {renderDelete()}
      <Footer />
      {renderLoading()}
      {notify}
    </DashboardLayout>
  );
}

export default Category;
